import React from "react";
import { CloseButton } from "@chakra-ui/react";
import Title from "../Title";
import KnownLearningToggle from "./KnownLearningToggle";
import SearchBar from "./SearchBar";

type ViewMode = "known" | "learning";

interface SegmentedViewHeaderProps {
  title: string;
  titleColor: string;
  viewMode: ViewMode;
  knownCount: number;
  learningCount: number;
  searchQuery: string;
  onViewModeChange: (mode: ViewMode) => void;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClose: () => void;
  searchPlaceholder?: string;
}

const SegmentedViewHeader: React.FC<SegmentedViewHeaderProps> = ({
  title,
  titleColor,
  viewMode,
  knownCount,
  learningCount,
  searchQuery,
  onViewModeChange,
  onSearchChange,
  onClose,
  searchPlaceholder = "Search...",
}) => {
  return (
    <>
      <div className="flex flex-row justify-between items-center mb-2">
        <Title text={title} className={`text-[${titleColor}]`} />
        <CloseButton onClick={onClose} />
      </div>

      <div className="mb-4 shadow-sm rounded-full">
        <KnownLearningToggle
          value={viewMode}
          onChange={onViewModeChange}
          knownCount={knownCount}
          learningCount={learningCount}
        />
      </div>

      {/* Search bar positioned below the tabs */}
      <div className="mb-4">
        <SearchBar
          searchQuery={searchQuery}
          onSearchChange={onSearchChange}
          placeholderText={searchPlaceholder}
        />
      </div>
    </>
  );
};

export default SegmentedViewHeader;
